import Vue from "vue";

const bus = new Vue();
let timer = null;

export function initRefresh({ intervalMs = 15000 } = {}) {
    const tick = () => bus.$emit("global-refresh");

    // 1) Quand on revient sur l’onglet / l’app reprend le focus
    const onVisible = () => { if (!document.hidden) tick(); };
    window.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", tick);
    window.addEventListener("pageshow", tick);

    // 2) Polling régulier
    if (timer) clearInterval(timer);
    timer = setInterval(tick, intervalMs);

    // 3) Un petit refresh initial (optionnel)
    setTimeout(tick, 250);

    // Fonction pour arrêter proprement si besoin
    return () => {
        clearInterval(timer);
        timer = null;
        window.removeEventListener("visibilitychange", onVisible);
        window.removeEventListener("focus", tick);
        window.removeEventListener("pageshow", tick);
    };
}

export function onRefresh(handler) {
    bus.$on("global-refresh", handler);
}

export function offRefresh(handler) {
    bus.$off("global-refresh", handler);
}

// Optionnel: pouvoir déclencher manuellement
export function triggerRefresh() {
    bus.$emit("global-refresh");
}
